export const URL_DISCORD = 'https://discord.gg/sceVSauMxG';
export const URL_INSTAGRAM = 'https://instagram.com/askokeyig';
export const URL_YOUTUBE = 'https://www.youtube.com/askokeyinc';
export const URL_CONSULTATION = 'https://kingofdrape.com/consultation';